import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/channels/guest/$channelId` activates the channel-thread
// column (col 2) under the GUEST audience. The Channels LAYOUT route
// (channels.tsx) reads `$channelId` from the leaf match and renders every column
// via ColumnLayout. Mirrors forms/$formId.
export const Route = createFileRoute(
  "/$orgSlug/$eventSlug/channels/guest/$channelId",
)({
  component: () => null,
})
